import _taggedTemplateLiteral from "/home/jenkins/agent/workspace/rtal_Jobs_Portal_Pipeline_master/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject, _templateObject2;

import React, { useRef, useEffect } from 'react';
import { components } from 'react-select';
import AsyncSelect from 'react-select/async-creatable';
import styled from 'styled-components';
import Fuse from 'fuse.js';
import { FieldContainer, Field, Label, FieldBefore } from '../field';
import { Icon } from '../icon';
import { useFieldValidation } from '../../hooks/validation-field';
import { makeCustomSup, makeAutocomplete } from './mixins';
import { Helper } from '../Helper';
var SelectField = styled(AsyncSelect)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  ", "\n"])), function (props) {
  return makeAutocomplete(props);
});
var CustomSup = styled.sup(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  ", "\n"])), function () {
  return makeCustomSup();
});

var ClearIndicator = function ClearIndicator(props) {
  return React.createElement(components.ClearIndicator, Object.assign({}, props), React.createElement(Icon, {
    name: "icon-light-close",
    color: "rgba(0, 0, 24, 0.16)",
    size: "16"
  }));
};

export var Autocomplete = function Autocomplete(_ref) {
  var id = _ref.id,
      name = _ref.name,
      value = _ref.value,
      options = _ref.options,
      defaultOptions = _ref.defaultOptions,
      asyncOptions = _ref.asyncOptions,
      _ref$placeholder = _ref.placeholder,
      placeholder = _ref$placeholder === void 0 ? 'Seleccione una opción' : _ref$placeholder,
      _onChange = _ref.onChange,
      _onInputChange = _ref.onInputChange,
      _onBlur = _ref.onBlur,
      onFocus = _ref.onFocus,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      _ref$cacheOptions = _ref.cacheOptions,
      cacheOptions = _ref$cacheOptions === void 0 ? true : _ref$cacheOptions,
      _ref$minQueryLength = _ref.minQueryLength,
      minQueryLength = _ref$minQueryLength === void 0 ? 2 : _ref$minQueryLength,
      _ref$loadingMessage = _ref.loadingMessage,
      _loadingMessage = _ref$loadingMessage === void 0 ? 'Cargando ...' : _ref$loadingMessage,
      _ref$maxMenuHeight = _ref.maxMenuHeight,
      maxMenuHeight = _ref$maxMenuHeight === void 0 ? 300 : _ref$maxMenuHeight,
      _ref$threshold = _ref.threshold,
      threshold = _ref$threshold === void 0 ? 0.7 : _ref$threshold,
      _ref$ignoreLocation = _ref.ignoreLocation,
      ignoreLocation = _ref$ignoreLocation === void 0 ? true : _ref$ignoreLocation,
      rules = _ref.rules,
      errors = _ref.errors,
      fieldOptions = _ref.fieldOptions,
      formatOptionLabel = _ref.formatOptionLabel,
      _ref$isClearable = _ref.isClearable,
      isClearable = _ref$isClearable === void 0 ? false : _ref$isClearable,
      _ref$isCreatable = _ref.isCreatable,
      isCreatable = _ref$isCreatable === void 0 ? false : _ref$isCreatable,
      _ref$isEditable = _ref.isEditable,
      isEditable = _ref$isEditable === void 0 ? false : _ref$isEditable,
      _ref$blurOnSelect = _ref.blurOnSelect,
      blurOnSelect = _ref$blurOnSelect === void 0 ? false : _ref$blurOnSelect,
      _ref$createLabel = _ref.createLabel,
      createLabel = _ref$createLabel === void 0 ? '' : _ref$createLabel,
      noBottomMargin = _ref.noBottomMargin,
      noOptionsMsg = _ref.noOptionsMsg;

  var defaultNoOpts = minQueryLength > 1 ? "Ingresa al menos ".concat(minQueryLength, " caracteres") : 'Ingresa al menos un caracter';

  var _useFieldValidation = useFieldValidation(rules, errors, name, disabled),
      fieldStates = _useFieldValidation.fieldStates,
      classes = _useFieldValidation.classes,
      inputValue = _useFieldValidation.inputValue,
      setInputValue = _useFieldValidation.setInputValue,
      setValue = _useFieldValidation.setValue,
      setActive = _useFieldValidation.setActive;

  var extraProps = isEditable ? {
    inputValue: inputValue
  } : null;
  var fuse = useRef();
  useEffect(function () {
    if (options) {
      fuse.current = new Fuse(options, {
        keys: ['label'],
        threshold: threshold,
        ignoreLocation: ignoreLocation
      });
    }
  }, [ignoreLocation, options, threshold]);
  useEffect(function () {
    if (isEditable && inputValue !== (value === null || value === void 0 ? void 0 : value.value)) {
      setInputValue(value);
    }
  }, [value]);

  var handleOnChange = function handleOnChange(option, callback) {
    setValue(option);

    if (isEditable) {
      setInputValue(option);
    }

    if (callback) {
      callback(name, option);
    }
  };

  var handleOnBlur = function handleOnBlur(event, callback) {
    setActive(false);

    if (callback) {
      callback(event);
    }
  };

  var loadOptionsHandler = function loadOptionsHandler(query) {
    var _a, _b;

    if (asyncOptions && query.length >= minQueryLength) {
      return asyncOptions(query);
    }

    if (options && query.length >= minQueryLength) {
      var filtered = (_b = (_a = fuse.current) === null || _a === void 0 ? void 0 : _a.search(query, {
        limit: 100
      }).map(function (v) {
        return v.item;
      })) !== null && _b !== void 0 ? _b : [];
      return Promise.resolve(filtered);
    }

    return Promise.resolve();
  };

  return React.createElement(FieldContainer, null, fieldOptions && fieldOptions.label && React.createElement(Label, {
    htmlFor: id || "autocomplete-".concat(name)
  }, fieldOptions.label, rules && rules.required && React.createElement(CustomSup, null, "*")), React.createElement(Field, Object.assign({}, fieldOptions, {
    states: Object.assign({}, fieldStates),
    className: classes
  }), fieldOptions && fieldOptions.before && React.createElement(FieldBefore, null, fieldOptions.before), React.createElement(SelectField, Object.assign({
    id: id || "autocomplete-".concat(name),
    name: name,
    placeholder: placeholder,
    defaultOptions: defaultOptions,
    cacheOptions: cacheOptions,
    loadOptions: loadOptionsHandler,
    createOptionPosition: "first",
    formatCreateLabel: function formatCreateLabel(labelInputValue) {
      return "".concat(createLabel).concat(labelInputValue);
    },
    formatOptionLabel: formatOptionLabel,
    noOptionsMessage: function noOptionsMessage() {
      return React.createElement(React.Fragment, null, noOptionsMsg ? noOptionsMsg : defaultNoOpts);
    },
    loadingMessage: function loadingMessage() {
      return React.createElement(React.Fragment, null, _loadingMessage);
    },
    isDisabled: disabled,
    onChange: function onChange(option) {
      return handleOnChange(option, _onChange);
    },
    onInputChange: function onInputChange(option, event) {
      return isEditable && event.action === 'input-change' && handleOnChange(option, _onInputChange);
    },
    onBlur: function onBlur(event) {
      return handleOnBlur(event, _onBlur);
    },
    onFocus: onFocus,
    onMenuOpen: function onMenuOpen() {
      return setActive(true);
    },
    value: value !== null && value !== void 0 ? value : null,
    components: {
      ClearIndicator: ClearIndicator
    },
    classNamePrefix: "select",
    blurInputOnSelect: blurOnSelect,
    isClearable: isClearable,
    isValidNewOption: function isValidNewOption(opt) {
      return isCreatable ? opt.length >= minQueryLength : false;
    },
    maxMenuHeight: maxMenuHeight
  }, fieldOptions, extraProps))), React.createElement(Helper, {
    name: name,
    fieldOptions: fieldOptions,
    errors: errors,
    noBottomMargin: noBottomMargin
  }));
};